import { Processor } from './processor.model';

export class AlertConfig {
  trigger: Object = {}
  processor: Processor = new Processor();
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/alert-config.ts